import React from 'react'

const ShiftReplacementSuccess = () => {
    return (
        <div>
            
        </div>
    )
}

export default ShiftReplacementSuccess